import "./../css/_app.scss";
// import pageTransitions from "./animations/transitions";
// import * as basicScroll from 'basicscroll'
import utils from "./utils";
import nav from "./nav";
import forms from "./forms";
import sliders from "./sliders";
import posts from "./posts";
import tabs from "./tabs";
import gallery from "./gallery";

import Aoe from "./aoe";

export default class App {
  constructor() {
    this.initDev(); // tests and shit
    this.initBody(); // runs on initialize & after barba
  }

  initBody() {
    sliders();
    posts();
    tabs();
    gallery();
    forms.handleForms();
    const aoe = new Aoe();

    setTimeout(() => {
      aoe.init({});
    }, 100);
  }

  initCore() {
    // pageTransitions(); // barbaajs
    nav.hamburger();

    // setTimeout(() => {
    //   window.scrollTo({
    //     top: 0,
    //     behavior: "smooth",
    //   });
    // }, 100);
  }

  initDev() {
    utils.clone("[data-clone]");
  }
}

function LoadApp() {
  const app = new App();
  app.initCore(); // runs on initialize
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", LoadApp);
} else {
  LoadApp();
}
